import { useResponsiveLayout } from '@plm-core/utils'
import { Tooltip } from '@design-systems/canvas-ui'

export const BreadcrumbWorkspace = ({
  workspaceId,
  workspaceDescription,
}: {
  workspaceId: string
  workspaceDescription: string
}) => {
  const { canvasScreenSize } = useResponsiveLayout()
  const isLgScreen = canvasScreenSize === 'lg'

  const screenSizeDescriptionLength = isLgScreen ? 15 : 60
  const modifiedDescription =
    workspaceDescription.length > screenSizeDescriptionLength
      ? `${workspaceDescription.substring(0, screenSizeDescriptionLength)}...`
      : workspaceDescription
  const isTruncated = workspaceDescription.length > screenSizeDescriptionLength

  return (
    <Tooltip
      content={workspaceDescription}
      location={isTruncated ? 'bottom' : 'none'}
    >
      {isLgScreen ? (
        `${workspaceId}: ${modifiedDescription}`
      ) : (
        <p>{workspaceId}</p>
      )}
    </Tooltip>
  )
}

export default BreadcrumbWorkspace
